export class UncontrolledTransactionConstants {
  public static readonly MIN_UNCONTROLLED_TRANSACTION_YEAR = 1900;
}
